import React from "react";

import MarkdownContainer from "../../MarkdownContainer";

import markdown from "../../../../markdown/universal/102_ip_migration.md";

const IpMigration = () => {
  return <MarkdownContainer markdown={markdown} />;
};

export default IpMigration;
